export default defineNuxtPlugin((nuxt) => {
  nuxt.vueApp.directive('focus-input', {
    mounted(el) {
      const input = el.querySelector('input')

      if (input) {
        nextTick(() => {
          input.focus()
        })
      }
    }
  })
})
